import { first, has, isArray } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export interface SearchCityOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Comuni: ComuneData[]
}

interface ComuneData {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  IdComune: number
  // eslint-disable-next-line @typescript-eslint/naming-convention
  NomeComune: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SiglaProvincia: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Cap: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isComuneData = (obj: any): obj is ComuneData =>
  obj && has(obj, 'IdComune') && has(obj, 'NomeComune') && has(obj, 'SiglaProvincia') && has(obj, 'Cap')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isComuneDataArr = (obj: any): obj is ComuneData[] => {
  if (isArray(obj)) {
    if (obj.length) {
      return isComuneData(first(obj))
    }
    return true
  }
  return false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSearchCityOutput = (obj: any): obj is SearchCityOutput =>
  has(obj, 'Comuni') && isComuneDataArr(obj.Comuni) && isBaseOutput(obj)
